export default
{
    ServiceTypes: [],
   ServiceType: {},
}
